import React from 'react'
import { Link } from 'react-router-dom';

const CheckoutConfirm = ({ containerObject, templateName, contentId, dataZone }) => {

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row  `}>
            <div class="row justify-content-center c-account-page c-school-page i-user-order-confirm-css">
                <div class="col-12 col-md-10 my-5 m-auto">
                    <div class="row align-items-center">
                        <div class="col-md-6 text-left">
                            <h1 class="c-account-heading mb-4 mb-md-0">
                                Thank You for Sending Your Order Request
                            </h1>
                        </div>
                        <div class="col-md-6 text-end">
                            <Link to="/">
                                <button type="submit" class="confirm-btn btn btn-secondary block c-school-btn mb-4 mb-md-0 i-user-order-confirm-button">
                                    Continue Shopping
                                </button>
                            </Link>
                            <Link to="/account/landing">
                                <button type="submit" class="confirm-btn btn btn-secondary block c-school-btn mb-md-0 mb-4 ml-2 i-user-order-confirm-button">
                                    My Account
                                </button>
                            </Link>
                        </div>
                    </div>
                    <div class="text-left mt-3 c-school-margin">
                        <p class="c-regular-text mb-3">Your quote request has been sent to our International Sales team. You should receive a response in 5 business days.</p>
                        <p class="c-regular-text mb-5">If you have questions about the status of your quote, placing orders, or have questions about products, please contact one of our International Sales Managers using the contact information below.</p>
                        <p class="c-regular-text mb-0">Napoleon Saca,International Sales Manager</p>
                        <ul class="c-inc-list">
                            <li class="mb-2">Phone: 336.586.4365</li>
                            <li>Email: napoleon.saca@carolina.com</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CheckoutConfirm;